/** venture/RecurStepRow.tsx — 타임라인 15번째 줄 「정기·결산 보고」 (2026-09-24)
 *  1~15단계처럼 한 줄로 보이되 순서 커서(p.step)와 무관한 반복 의무 — 결성등록(7단계 완료) 후 열리고,
 *  보고 기간이 오면 주황(기간 중)·빨강(지연) 배지로 알린다. */
import React from 'react';
import Step15Report from './Step15Report';
import { isRegistered, repAlert, nextPeriod } from './report';
import type { Project } from './types';

interface Props { p: Project; open: boolean; onToggle: () => void; onPatch: (patch: Partial<Project>) => void; toast: (m: string) => void; }

export default function RecurStepRow({ p, open, onToggle, onPatch, toast }: Props) {
  const reg = isRegistered(p);
  const alert = reg ? repAlert(p) : null;
  const next = reg ? nextPeriod(p) : null;
  const cls = !reg ? 'todo' : alert ? 'cur' : 'done';
  return (
    <div className={'step recur ' + cls} id="step-recur">
      <div className="rail"><div className="dot"><span>🔁</span></div><div className="line" /></div>
      <div className="body">
        <div className="t" style={reg ? { cursor: 'pointer' } : undefined} title={reg ? (open ? '클릭하면 닫습니다' : '클릭하면 엽니다') : '조합 결성등록(7단계) 후 열립니다'} onClick={() => { if (reg) onToggle(); }}>
          정기·결산 보고 (VICS){' '}
          {!reg
            ? <span className="pill p-gray" style={{ fontSize: 10 }}>결성등록 후 시작</span>
            : alert
              ? <span className={'pill ' + (alert.stat === 'late' ? 'p-red' : 'p-amber')} style={{ fontSize: 10 }}>📅 {alert.label}</span>
              : next
                ? <span className="pill p-green" style={{ fontSize: 10 }}>다음 · {next.label} {next.from.slice(5).replace('-', '/')}~</span>
                : <span className="pill p-amber" style={{ fontSize: 10 }}>결성등록일 입력 필요</span>}
          {open ? <span className="pill p-blue" style={{ fontSize: 10, marginLeft: 4 }}>열람 중</span> : null}
          {reg && !open ? <span style={{ color: 'var(--muted)', fontWeight: 400, fontSize: 11 }}> · 클릭하여 열기</span> : null}
        </div>
        <div className="d">결성등록 후 매년 반복 · 정기보고 1/1~1/31 · 7/1~7/31 (VICS 확정/전송) · 결산보고 1/1~3/31 (감사의견서 또는 자금운용현황 첨부)</div>
        {open ? <Step15Report p={p} onPatch={onPatch} toast={toast} /> : null}
      </div>
    </div>
  );
}
